import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import {
  Field,
  arrayRemove,
  change
} from 'redux-form';
import { connect } from 'react-redux';

import { resolveObjPath } from 'components/Common/Inputs/NestedArrayObjectField';

class NestedArrayStringFieldInput extends Component {
  static propTypes = {
    input: PropTypes.shape({
      value: PropTypes.any,
      name: PropTypes.string
    }).isRequired,
    meta: PropTypes.shape({
      form: PropTypes.string,
      dispatch: PropTypes.any
    }).isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    className: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    initValue: PropTypes.any
  };

  static defaultProps = {
    placeholder: '',
    type: 'text',
    className: '',
    initValue: undefined
  };

  componentDidMount() {
    const {
      input: { name, value },
      meta: { dispatch, form },
      initValue
    } = this.props;
    if ((value === null || value === undefined || value === '') && initValue !== undefined) {
      dispatch(change(form, name, initValue));
    }
  }

  render() {
    const {
      input,
      placeholder,
      type,
      className
    } = this.props;
    return (
      <div>
        <input
          type={ type }
          { ...input }
          placeholder={ placeholder }
          className={ className }
        />
      </div>
    );
  }
}

const NestedArrayStringFieldComponent = ({
  dispatch,
  name,
  rootField,
  formName,
  initValue
}) => (
  <Field
    name={ name }
    component={ NestedArrayStringFieldInput }
    className="form-input"
    rootField={ rootField }
    initValue={ initValue }
    onBlur={ (event, newVal, prevVal) => {
      if (!prevVal && !newVal) {
        event.preventDefault();
      }
    } }
    normalize={ (value, prevVal, allValues, prevAllValues) => {
      const rootFieldValue = resolveObjPath(rootField, allValues);
      if (rootFieldValue) {
        const itemIndex = name.replace(/(^.*\[|\].*$)/g, '');
        const rootFieldItem = rootFieldValue[itemIndex];
        if (rootFieldItem === '' || rootFieldItem === null) {
          dispatch(arrayRemove(formName, rootField, itemIndex));
          return undefined;
        }
      }
      return value;
    } }
  />
);

NestedArrayStringFieldComponent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  rootField: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  initValue: PropTypes.any
};

NestedArrayStringFieldComponent.defaultProps = {
  initValue: undefined
};

const mapDispatchToProps = dispatch => ({ dispatch });

const mapStateToProps = state => ({ formName: Object.getOwnPropertyNames(state.form)[0] });

// eslint-disable-next-line import/prefer-default-export
export const NestedArrayStringField = connect(
  mapStateToProps,
  mapDispatchToProps
)(NestedArrayStringFieldComponent);
